import React, { useState } from "react";
import { useRecoilState } from "recoil";
import { showKeyboardState } from "../recoil/showKeyboard";
import Keyboard from "../components/Keyboard";

const KeyboardController = () => {
  const [showKeyboard, setShowKeyboard] = useRecoilState(showKeyboardState);

  const handleCloseKeyboard = () => {
    setShowKeyboard((prev) => ({
      ...prev,
      showKeyboard: false,
    }));
  };


  return (
    <Keyboard
      showKeyboard={showKeyboard.showKeyboard}
      setShowKeyboard={handleCloseKeyboard}
      input={showKeyboard.input}
      setInput={(value) =>
        setShowKeyboard((prev: any) => ({ ...prev, input: value }))
      }
    />
  );
};

export default KeyboardController;
